import { IDocument } from "../interfaces/IDocument";
import { useGenerateContractDocument } from "../hooks/data/data_contract";
import { IContractDocumentAnswer } from "../interfaces/IContractDocumentAnswer";

export const useGeneratePdf = () => {
    const { generateContractDocument, isPendingGenerateContractDocument } = useGenerateContractDocument();

    const generatePdf = async (
        callFunction: (data: IDocument) => void,
        onError: () => void,
        contractObject: { id: number },
        contractDocumentAnswerArray: IContractDocumentAnswer[] = [],
    ) => {
        try {
            const dataFromBackend = await generateContractDocument({
                idContract: contractObject.id,
                contractDocumentAnswerArray,
            });

            callFunction(dataFromBackend);
        } catch (error) {
            console.error("Error generating PDF:", error);
            onError();
        }
    };

    return { generatePdf, isPendingGenerateContractDocument };
};
